module.exports = __webpack_public_path__ + "41af26117a253dd83bc79961a54a710f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/vml.png
// module id = 6A50
// module chunks = 0